import React, { useEffect, useState } from "react";
import { routes } from "../../api/routes";
import { callApi } from "../../api/apiCaller";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/loader/loader";

const AboutUs = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [aboutUs, setAboutUs] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);

  const getAboutUs = () => {
    const getRes = (res) => {
      console.log("res of getAboutUs", res);
      const aboutUsContent = res?.data?.data?.[0]?.data || "";
      setAboutUs(aboutUsContent);
    };

    callApi("GET", routes.getAboutUs, null, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  useEffect(() => {
    getAboutUs();
  }, [getServiceapi]);
  return (
    <div>
      <Loader loading={isloading} />
      <div
        style={{ marginLeft: "5rem", marginTop: "5rem", fontSize: ".8rem" }}
        dangerouslySetInnerHTML={{ __html: aboutUs }}
      />
    </div>
  );
};

export default AboutUs;
